import type { TFolder } from '../../entities/folder';

/** What a drag carries: one item (the selection comes along if it is part of it) or a folder. */
export type TDragged = { kind: 'item'; id: string } | { kind: 'folder'; folder: TFolder };

/** What a drop target is: a folder, or the root (`null`). */
export interface IDropTarget {
  folderId: string | null;
}

export const dropId = (folderId: string | null) => `drop:${folderId ?? 'root'}`;
